import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import AuthService from "../../../../api/AuthService";
import PayrollSalaryListPage from "../../../../entities/DashboardPage/HRModule/Payroll/payrollSalaryListPage";
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";

const PayrollSalaryList = () => {
  const { state } = useLocation();
  const { item, payrollData } = state || {};
  const [salaryData, setSalaryData] = useState("");

  useEffect(() => {
    getPayrollPayslip();
  }, []);

  const getPayrollPayslip = async () => {
    LoaderHelper.loaderStatus(true);

    try {
      const result = await AuthService.getPayrollPayslipData(
        item?._id,
        payrollData?._id
      );
      if (result?.success) {
        setSalaryData(result?.data);
        LoaderHelper.loaderStatus(false);
      } else {
        LoaderHelper.loaderStatus(false);
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
    }
  };

  return (
    <PayrollSalaryListPage salaryData={salaryData} payrollData={payrollData} />
  );
};

export default PayrollSalaryList;
